import { render, staticRenderFns } from "./ProductDetailLayer.vue?vue&type=template&id=d8d55be0&scoped=true&"
import script from "./ProductDetailLayer.vue?vue&type=script&lang=js&"
export * from "./ProductDetailLayer.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailLayer.vue?vue&type=style&index=0&id=d8d55be0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d55be0",
  null
  
)

export default component.exports